import { useTranslation } from 'react-i18next';
import { Button } from '../ui.tsx';

export const SCHEDULE_VIEWS = ['list', 'week', 'month'] as const;
export type CalendarView = (typeof SCHEDULE_VIEWS)[number];
export type ScheduleView = CalendarView | 'map';

/** The same named choices stay available on the calendar and the day map. */
export function ScheduleViewSelector({
  view,
  onSelect,
  mapAvailable,
  disabled = false,
}: {
  view: ScheduleView;
  onSelect: (view: ScheduleView) => void;
  mapAvailable: boolean;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const options: readonly ScheduleView[] = mapAvailable ? [...SCHEDULE_VIEWS, 'map'] : SCHEDULE_VIEWS;
  return (
    <div role="group" aria-label={t('schedule.page.viewGroupLabel')} className="flex flex-wrap gap-1">
      {options.map((option) => (
        <Button
          key={option}
          variant={view === option ? 'primary' : 'secondary'}
          aria-pressed={view === option}
          disabled={disabled}
          onClick={() => {
            if (option !== view) onSelect(option);
          }}
        >
          {t(`schedule.page.view.${option}`)}
        </Button>
      ))}
    </div>
  );
}
